export enum ProductsType {
  MOBILE = 'mobile',
  CAR = 'car',
  MOTO = 'moto',
  LAPTOP = 'laptop',
  VEHICLE = 'vehicle',
  PICKUP_TRICK = 'car',
  PERSON = 'person',
  TRACTOR = 'tractor',
}
